import { render, staticRenderFns } from "./NavAnchorLink.vue?vue&type=template&id=0dd30649&scoped=true&"
import script from "./NavAnchorLink.vue?vue&type=script&lang=ts&"
export * from "./NavAnchorLink.vue?vue&type=script&lang=ts&"
import style0 from "./NavAnchorLink.vue?vue&type=style&index=0&id=0dd30649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd30649",
  null
  
)

export default component.exports